import * as React from "react";
import { useState, useMemo } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import InhibitorBaseTable from "../../JobPage/components/inhibitor-table/InhibitorBaseTable";
import { Column } from "primereact/column";
import { useViewerContext } from "../viewer-context";
import ChangeEnum from "../../JobPage/interfaces/frontend/ChangeEnum";
import Icons from "../../JobPage/components/Icons";
import InhibitorEmptyMessage from "../../JobPage/components/inhibitor-table/InhibitorEmptyMessage";

export function ViewerInhibitorModal() {

  const {
    inhibitors,
    selectedInhibitors, setSelectedInhibitors,
    inhibitorModalOpen, toggleInhibitorModal,
  } = useViewerContext();

  const [showOnlySelected, setShowOnlySelected] = useState(false);
  const [showOnlyAssociated, setShowOnlyAssociated] = useState(false);
  const [differenceFilter, setDifferenceFilter] = useState<ChangeEnum | null>(null);

  const selectedIds = useMemo(() => {
    return new Set(selectedInhibitors.map(inh => inh.id));
  }, [selectedInhibitors]);

  const screenInhibitors = useMemo(() => {
    let out = inhibitors;
    if (showOnlyAssociated) {
      out = out.filter(inh => inh.associatedDrug);
    }
    if (differenceFilter !== null) {
      out = out.filter(inh => inh.bindingEnergyDiffClass === differenceFilter);
    }
    if (showOnlySelected) {
      out = out.filter(inh => selectedIds.has(inh.id));
    }
    return out;
  }, [inhibitors, showOnlyAssociated, differenceFilter, showOnlySelected, selectedIds]);

  return (<Modal
    unmountOnClose={false}
    zIndex={1}
    size="xl"
    isOpen={inhibitorModalOpen}
    centered
    fade={false}
    className="ll-molstar-inhibitor-modal"
    toggle={toggleInhibitorModal}
  >
    <ModalHeader tag="div" toggle={toggleInhibitorModal}>
      <h5>Select inhibitors</h5>
      <label>
        <input
          type="checkbox"
          checked={showOnlySelected}
          onChange={({target}) => setShowOnlySelected(target.checked)}
        />
        <span>show only selected</span>
      </label>
      <label>
        <input
          type="checkbox"
          checked={showOnlyAssociated}
          onChange={({target}) => setShowOnlyAssociated(target.checked)}/>
        <span>show only associated drugs {Icons.associatedDrug}</span>
      </label>
    </ModalHeader>
    <ModalBody>
      <InhibitorBaseTable
        screenInhibitors={screenInhibitors}
        differenceFilter={differenceFilter}
        setDifferenceFilter={setDifferenceFilter}
        emptyMessage={(...args) => InhibitorEmptyMessage({
          showOnlySelected,
          showOnlyAssociated,
          differenceFilter,
        }, ...args)}
        scrollHeight="min(500px, calc(85vh - 200px))"
        className="ll-no-select-all"
        columnsBefore={<Column selectionMode="multiple"/>}
        dataTableProps={{
          selection: selectedInhibitors,
          onSelectionChange: e => setSelectedInhibitors(e.value),
        }}
      />
    </ModalBody>
    <ModalFooter>
      <Button onClick={toggleInhibitorModal}>Close</Button>
    </ModalFooter>
  </Modal>)
}